import { render, staticRenderFns } from "./videoIndex.vue?vue&type=template&id=e1561d92"
import script from "./videoIndex.vue?vue&type=script&lang=js"
export * from "./videoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports